import React, {createContext, useContext, useEffect, useState} from 'react';

import "../../_asset/css/lobby.css"
import {with_comma} from "../../util/comma";
import {useParams, useSearchParams} from 'react-router-dom';
import api, {ApiErrorHandler} from "../../util/api";
import {UserContext} from "../_root";
import {compL as compL_slot, GameCompanyListType as GameCompanyListType_slot} from "../../data/gameData_slot";
import {compL as compL_casino, GameCompanyListType as GameCompanyListType_casino} from "../../data/gameData_casino";
import {Player} from "@lottiefiles/react-lottie-player";

import ready_casino from "../../_asset/lottie/ready_casino.json"
import loading from "../../_asset/lottie/loading.json"
import {gameType} from "../../component/provider/lobby_modal_provider";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faWonSign} from "@fortawesome/free-solid-svg-icons";
import {isMobile} from "react-device-detect";

import swal from "sweetalert"
import { Logo_1 } from '../../component/common/logo';


type all_type = GameCompanyListType_slot & GameCompanyListType_casino
interface RootContextInterface {
    company: string,
    SetCompany: (arg: string) => void
}
const RootContext = createContext<RootContextInterface>({
    company: "",
    SetCompany: () => {}
})

export default function LobbyRoot(){
    const [company, setCompany] = useState<string>("")

    function SetCompany(selectCompany: string){
        setCompany(selectCompany)
    }
    return (
        <RootContext.Provider value={{ company, SetCompany }}>
            {/*<Lobby/>*/}
        </RootContext.Provider>
    )
}

export function Lobby({vendor, type, handleClose}: {vendor: string, type: gameType, handleClose: Function}) {
    const { User } = useContext(UserContext)
    return (
        <div className={'lobby'} rel={'root'}>
            <header className={'lobby-header'}>
                <Logo_1 />

                <div className={'user-money'}>
                    <FontAwesomeIcon icon={faWonSign} />
                    {
                        ` ${with_comma(User ? User.money : Number(sessionStorage.getItem('money')))}`
                    }
                </div>
            </header>

            <SlotLobby vendor={vendor} type={type} handleClose={handleClose}/>
        </div>
    );
}

interface vendorGameListInterface {
    uid: string,
    title: string,
    vendor: string,
    thumbnail: string
}
export function SlotLobby({vendor, type, handleClose}: {vendor: string, type: gameType, handleClose: Function}){
    const [gameList, setGameList] = useState<vendorGameListInterface[]>()
    const [listShow, setListShow] = useState<boolean>(false)

    let compL;
    if(type == 'casino'){
        compL = compL_casino
    }else{
        compL = compL_slot
    }

    useEffect(()=> {
        let apiUrl: string;
        // console.log(vendor)
        switch(vendor){
            case "PragmaticPlay J" :
                apiUrl = `/api/game/games/pragmatic/`;
            break;
            default:
                apiUrl = `/api/game/games/honor/?vendor=${vendor}`;
                break;
        }
        api(apiUrl)
            .then((res)=> res.json())
            .then((data: vendorGameListInterface[]) => setGameList(data))
            .catch((res: Response)=> {
                ApiErrorHandler(res, ()=> {
                    handleClose()
                })
            })
    }, [])
    useEffect(()=> {
        if(gameList){
            setListShow(true)
        }else{
            setListShow(false)
        }
    }, [gameList])

    return (
        <main className={'lobby-main'}>
            <div className={'select-company'}>
                <div className={'company'}>
                    {
                        // @ts-ignore
                        <img src={compL[vendor as all_type].logo} title={vendor}/>
                    }
                </div>
                {/*<div className={'company'}>{vendor}</div>*/}
            </div>
                {
                    listShow
                        ? gameList && gameList.length
                            ? <div className={'company-list'}>
                                {
                                    gameList.map((list, index)=> {
                                        if(list.thumbnail){
                                            return (
                                                <CompanyItems key={index} list={list} vendor={vendor ? vendor : ""}/>
                                            )
                                        }
                                    })
                                }
                            </div>
                            : <div className={'ready'}>
                                <Player src={ready_casino}
                                        autoplay={true}
                                        loop={true}></Player>
                                <p>준비중 입니다.</p>
                            </div>
                    : <div className={'loading'}>
                            <Player src={loading}
                                    autoplay={true}
                                    style={{ width: "10rem", height: "10rem" }}
                                    loop={true}></Player>
                        </div>
                }
        </main>
    )
}

function CompanyItems({list, vendor}: {list: vendorGameListInterface, vendor: string}){
    const [imgLoadState, setImageLoadState] = useState<boolean>(true)

    if(imgLoadState){
        return (
            <div className={'company-items'}
                 onClick={e=> {
                     if(isMobile){
                         window.open(`/gameLobby/${vendor}/?uid=${list.uid}&vendor=${list.vendor}`,
                             `${list.vendor}_${list.uid}`)
                     }else{
                         window.open(`/gameLobby/${vendor}/?uid=${list.uid}&vendor=${list.vendor}`,
                             `${list.vendor}_${list.uid}`, `width=1200 height=640`)
                     }
                 }}
            >
                <div className={'game-image'}>
                    <img src={list.thumbnail} onError={e=>setImageLoadState(false)}/>
                </div>
                <div className={'game-name'}>
                    {list.title}
                </div>
            </div>
        )
    }else{
        return <></>
    }
}

